// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KIWdEV86xB0BTTLNGz4A{background:var(--light-blue-a-15);border-radius:8px;justify-content:space-between;margin-top:16px;padding-left:20px;display:flex;position:relative}.xKspBeG3wpMaaLoUiUKm{flex-direction:column;align-items:flex-start;gap:24px;min-width:156px;padding-top:20px;padding-bottom:20px;display:flex}.xKspBeG3wpMaaLoUiUKm .NN0ncWAugM9l2JjrwwwV{color:var(--light-blue-70);gap:8px;display:flex}.AJsOThhbM20AHY3zrTYz{justify-content:center;gap:18px;width:100%;display:flex}.oxW8Kr4TQwOWiOEO2IK1{padding-top:24px;padding-bottom:24px}.w3bOzYUqsQ0EI3xTvAAs{padding-top:16px;padding-right:16px;position:absolute;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `KIWdEV86xB0BTTLNGz4A`,
	"left": `xKspBeG3wpMaaLoUiUKm`,
	"title": `NN0ncWAugM9l2JjrwwwV`,
	"right": `AJsOThhbM20AHY3zrTYz`,
	"wrapBanner": `oxW8Kr4TQwOWiOEO2IK1`,
	"wrapClose": `w3bOzYUqsQ0EI3xTvAAs`
};
export default ___CSS_LOADER_EXPORT___;
